import * as React from 'react';

const SvgAiraFAB = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    fill="none"
    viewBox="0 0 60 60"
  >
    <g filter="url(#filter0_dd_210_16984)" transform="translate(-6 -2)">
      <rect
        width="60"
        height="60"
        x="6"
        y="2"
        fill="url(#paint0_linear_210_16984)"
        rx="30"
      />
      <g clipPath="url(#clip0_210_16984)">
        <path
          fill="#fff"
          d="M44.75 28.25l1.563-3.438 3.437-1.562-3.438-1.563-1.562-3.437-1.563 3.438-3.437 1.562 3.438 1.563zm-9.375.625L32.25 22l-3.125 6.875L22.25 32l6.875 3.125L32.25 42l3.125-6.875L42.25 32zm9.375 6.875l-1.563 3.438-3.437 1.562 3.438 1.563 1.562 3.437 1.563-3.438 3.437-1.562-3.438-1.563z"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_210_16984"
        x1="6"
        x2="66"
        y1="31.854"
        y2="32.146"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.39" stopColor="#7489FF" />
        <stop offset="1" stopColor="#5CBEFF" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgAiraFAB;
